module.exports = __webpack_public_path__ + "img/elbill.bc5d2642.png";